import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Panel,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  FormGroup,
  Checkbox
} from 'react-bootstrap'
import autobind from 'autobind-decorator'
import Select from 'react-select'
import RequiredLabel from './requiredLabel'
import { genders } from '../redux/formSchema'
import * as _ from 'lodash'
import { change as changeFieldValue } from 'redux-form'
import {
  getObjVal,
  getRoomsOptions,
  getRoomClassName,
  getRoomDisplayNameById,
  isEmpty
} from '../utils'
import { connect } from 'react-redux'
import {
  guestTypeOptionsSelector,
  shouldCollectGuestInformationSelector
} from '../redux/modules/guestEntryFormModule'
import Input from '../components/elements/input'
import { roomTypes } from '../constants/roomConstants'

@autobind
class GuestInfoInput extends Component {
  static propTypes = {
    onChangeGuestInfo: PropTypes.func,
    index: PropTypes.number,
    totalGuests: PropTypes.number,
    dispatch: PropTypes.func,
    fields: PropTypes.object,
    authenticated: PropTypes.bool
  }

  buildInput(params) {
    const { label, field, required, type } = params
    const inputLabel = <RequiredLabel label={label} required={required} />
    return (
      <Col sm={12} xs={12} md={6} lg={3}>
        <Input
          {...field}
          value={getObjVal(field.value) || ''}
          type={type}
          label={inputLabel}
          help={field.touched && field.error}
          bsStyle={field.touched && field.error ? 'error' : null}
        />
      </Col>
    )
  }

  updateSelectedRooms(room, roomId, guestIndex) {
    const {
      selectedRooms,
      rooms,
      fields: { gender }
    } = this.props
    /* let obj = selectedRooms.map((selectedRoom, selectedRoomIdx) => {
         _.find(selectedRooms, (room) => { return room.roomId === roomId })
         }) */
    const prevRoomField = _.find(selectedRooms, {
      guestsIndxs: [{ ordIndex: guestIndex }]
    })
    if (prevRoomField) {
      const prevGuestField = _.find(prevRoomField.guestsIndxs, {
        ordIndex: guestIndex
      })
      if (prevGuestField) {
        prevGuestField.ordIndex = -1
      }
    }
    const currentRoom = _.find(selectedRooms, room => {
      return room.roomId === roomId
    })
    if (currentRoom) {
      const currentGuest = _.find(currentRoom.guestsIndxs, guestOrd => {
        return guestOrd.ordIndex < 0
      })
      if (currentGuest) {
        currentGuest.ordIndex = guestIndex
      }
    }
    this.props.dispatch(
      changeFieldValue(
        'roomSelection',
        'guestDetails[' + guestIndex + '].room',
        roomId
      )
    )
    if (
      (!rooms[getObjVal(roomId)] ||
        (rooms[getObjVal(roomId)] &&
          rooms[getObjVal(roomId)].gender === 'none')) &&
      gender
    ) {
      this.props.dispatch(
        changeFieldValue(
          'roomSelection',
          'guestDetails[' + guestIndex + '].gender',
          getObjVal(gender)
        )
      )
    } else if (
      !rooms[getObjVal(roomId)] ||
      (rooms[getObjVal(roomId)] && rooms[getObjVal(roomId)].gender === 'none')
    ) {
      this.props.dispatch(
        changeFieldValue(
          'roomSelection',
          'guestDetails[' + guestIndex + '].gender',
          ''
        )
      )
    } else {
      this.props.dispatch(
        changeFieldValue(
          'roomSelection',
          'guestDetails[' + guestIndex + '].gender',
          rooms[getObjVal(roomId)].gender
        )
      )
    }
  }

  render() {
    const {
      selectedRooms,
      guestIndex,
      totalGuests,
      guestTypeOptions,
      fields: {
        room,
        firstName,
        lastName,
        email,
        phone,
        guestType,
        gender,
        isMeditator
      },
      rooms,
      authenticated,
      shouldCollectGuestInformation
    } = this.props
    let roomGender = ''
    const roomsList = _.filter(selectedRooms, roomOption => {
      let guestContainsRoomId = false
      const keepRoom = _.find(roomOption.guestsIndxs, guestOrd => {
        if (guestOrd.ordIndex === guestIndex) {
          guestContainsRoomId = true
        }
        return guestContainsRoomId || guestOrd.ordIndex < 0
      })
      return keepRoom
    })
    const roomOptions = getRoomsOptions(roomsList, rooms)

    let genderOptions = [
      { label: 'Male', value: 'male' },
      { label: 'Female', value: 'female' }
    ]
    const isChild = guestType.value
      ? getObjVal(guestType.value) === 'child'
      : false
    let tooltip = <div />
    const roomInfoMsgs = {
      Lodge: 'All guests staying in the Lodge must be at least 7 years old',
      'Queen Suite':
        'All guests staying in the [king/queen] suite must be at least 14 years old',
      'King Suite':
        'All guests staying in the [king/queen] suite must be at least 14 years old',
      [roomTypes.cabin]: 'Cabin guests must be at least 18 years old'
    }
    if (getObjVal(room)) {
      const roomObj = rooms[getObjVal(room)]
      roomGender = roomObj.gender

      if (roomObj.gender === 'male') {
        genderOptions = [{ label: 'Male', value: 'male' }]
      } else if (roomObj.gender === 'female') {
        genderOptions = [{ label: 'Female', value: 'female' }]
      }
      tooltip = (
        <Tooltip
          id='tooltip'
          className={
            guestIndex === 0 || (roomObj && roomInfoMsgs[roomObj.type])
              ? 'fade in tooltip top'
              : 'age-tooltip fade in tooltip top'
          }
        >
          {roomObj.type === roomTypes.cabin
            ? roomInfoMsgs[roomObj.type]
            : guestIndex === 0
            ? `Paying guest must be ${guestTypeOptions[0].label} years old.`
            : roomInfoMsgs[roomObj.type]
            ? roomInfoMsgs[roomObj.type]
            : ''}
        </Tooltip>
      )
    }
    const displayCondition =
      isChild && guestIndex > 0
        ? false
        : authenticated
        ? guestIndex === 0
        : true
    const inputFieldParams = [
      {
        label: 'First Name',
        field: firstName,
        required: displayCondition,
        type: 'text'
      },
      {
        label: 'Last Name',
        field: lastName,
        required: displayCondition,
        type: 'text'
      },
      {
        label: 'Email',
        field: email,
        required: displayCondition,
        type: 'text'
      },
      {
        label: 'Phone Number',
        field: phone,
        required: displayCondition,
        type: 'number'
      }
    ]
    const selectedRoomVal = _.find(roomOptions, { value: getObjVal(room) })
      ? getObjVal(room)
      : ''
    const inputFields = (
      <Col sm={12}>
        <Row>
          <div className='guest-details-header'>
            <div className='label label-large label-dark-blue arrowed-right'>
              Participant {guestIndex + 1}
            </div>
            <div
              className={
                'rt-shape pull-right ' +
                (!isEmpty(getObjVal(room)) ? getRoomClassName(room, rooms) : '')
              }
            />
            <div className='rt-shape-text pull-right'>
              {getRoomDisplayNameById(room, rooms)}
            </div>
          </div>
        </Row>
        <Row>
          <Col sm={12} xs={12} md={6} lg={3}>
            <Input
              label={<RequiredLabel label='Room' required />}
              help={room.touched && room.error}
              bsStyle={room.touched && room.error ? 'error' : null}
            >
              <Select
                value={selectedRoomVal}
                options={roomOptions}
                clearable={false}
                disabled={false /* TODO: disable if needed */}
                onChange={value => {
                  this.updateSelectedRooms(room, value, guestIndex)
                }}
                {...this.props}
              />
            </Input>
          </Col>
          <Col sm={12} xs={12} md={6} lg={3}>
            <Input
              label={<RequiredLabel label='Age' required />}
              help={guestType.touched && guestType.error}
              bsStyle={guestType.touched && guestType.error ? 'error' : null}
            >
              <OverlayTrigger placement='top' overlay={tooltip}>
                <Select
                  value={getObjVal(guestType.value)}
                  options={guestTypeOptions}
                  clearable={false}
                  disabled={
                    guestIndex === 0 && totalGuests > 1 ? true : undefined
                  }
                  onChange={guestType.onChange}
                  required
                  {...this.props}
                />
              </OverlayTrigger>
            </Input>
          </Col>
          {shouldCollectGuestInformation ? (
            <Col sm={12} xs={12} md={6} lg={3}>
              <Input
                label={
                  <RequiredLabel label='Gender' required={displayCondition} />
                }
                help={gender.touched && gender.error}
                bsStyle={gender.touched && gender.error ? 'error' : null}
              >
                <Select
                  value={
                    selectedRoomVal
                      ? genders.indexOf(roomGender) >= 0
                        ? roomGender
                        : getObjVal(gender.value)
                      : ''
                  }
                  options={genderOptions}
                  clearable={false}
                  disabled={false /* TODO: disable if needed */}
                  onChange={gender.onChange}
                  {...this.props}
                />
              </Input>
            </Col>
          ) : null}
          {authenticated && shouldCollectGuestInformation ? (
            <Col sm={12} xs={12} md={6} lg={3}>
              <FormGroup>
                <Checkbox {...isMeditator}>
                  {<strong>Is meditator</strong>}
                </Checkbox>
              </FormGroup>
            </Col>
          ) : null}
        </Row>
        <Row>
          {shouldCollectGuestInformation &&
            inputFieldParams.map(this.buildInput)}
        </Row>
      </Col>
    )

    return (
      <div
        className={
          'each-guest-details ' +
          (room.value ? getRoomClassName(room, rooms) : '')
        }
      >
        <Panel>
          <form
            data-test-id={
              room.value ? 'form-' + getRoomClassName(room, rooms) : 'guest1'
            }
            className=''
          >
            {inputFields}
          </form>
        </Panel>
      </div>
    )
  }
}

export default connect((state, ownProps) => {
  const { guestIndex } = ownProps
  return {
    guestTypeOptions: guestTypeOptionsSelector(state, guestIndex),
    shouldCollectGuestInformation: shouldCollectGuestInformationSelector(
      state,
      guestIndex
    )
  }
})(GuestInfoInput)



// WEBPACK FOOTER //
// ./src/components/guestInfoInput.js